module.exports = __webpack_public_path__ + "static/media/19ESCAP26.eb67f5d2.jpg";